const jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
// import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';

const app = {
    /** Initialize */
    init() {

        // Initialize sliders
        this.initSliders();

        // Open search overlay
        this.toggleSearchOverlay();

        // Initialize subnav
        this.initSubnav();

        // Initialize sidebar
        this.initSidebar();

        // Show more function
        this.showMoreBlogs();

        // this.openSubnavitems();
        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));

    },
    /** Handles the scroll event */
    windowScrollHandler() {
        $('header').toggleClass('scrolled', $(window).scrollTop() > 0);
    },

    initSubnav() {
        $(".subnav").on('click', function(e) {
            $(this).children('.toggle').toggleClass('open');
            $(this).siblings('li').find('.toggle').removeClass('open');
            e.stopPropagation();
        });

        $(".toggle").on('click', function(e) {
            e.stopPropagation();
        });

        $(document).on('click', function() {
            $(".toggle").removeClass('open');
        });
    },

    /** Open search overlay */
    toggleSearchOverlay() {

        $('.toggle-search-box, .search-box .close-search-box').click(function (e) {
            e.preventDefault();
            $(".search-box").toggleClass('is-opened');
        });
    },

    initSidebar() {
        if ($(window).width() < 1024) {
            if($('.display').length) {
                $('.side-heading, .side-text').hide();    
            } 

            else {
                $('.heading, .test').show();
            }
        }
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $("header").toggleClass('has-opened-nav');
        $(".hamburger").toggleClass('is-active');
        $("header .container").toggleClass('opened'); 
        $("nav.navigation").toggleClass('visible');
        // $(".navigation-overlay").toggleClass('is-active');
        $("body").toggleClass('is-locked');
    },  

     /** Init sliders */
    initSliders() {
        if ($('.pageheader .image-slider').length) {
            $('.pageheader .image-slider').slick( {
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 6000,
                infinite: true,
                arrows: false,
            });
        };
    },

    showMoreBlogs() {
        $(".loadmoreblogs").on('click', function (e) {
            e.preventDefault();
            $(this).parent().parent().parent().find($('.col:hidden')).slice(0, 6).slideDown().css('display', 'flex');
        });
    },
};

$(document).ready($.proxy(app.init, app));

// document.addEventListener("DOMContentLoaded", function(event) {
//    document.querySelectorAll('img').forEach(function(img){
//     img.onerror = function(){this.style.display='none';};
//    })
// });

// jQuery(function($) {
//   $('a[href*="#"]:not([href="#"])').click(function() {
//       var target = $(this.hash);
//         $('html,body').stop().animate({
//           scrollTop: target.offset().top - 85
//         }, 'linear');   
//   });    
//     if (location.hash){
//     var id = $(location.hash);
//     }
//     $(window).load(function() {
//     if (location.hash){
//         $('html,body').animate({scrollTop: id.offset().top -85}, 'linear')
//     };
//     });
// })(jQuery);
